import React, { useState, useEffect } from "react";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";

const containerStyle = {
    width: "50%",
    height: "50vh",
};

// Default center (e.g., a fallback location)
const center = {
    lat: 37.7749, // Default to San Francisco
    lng: -122.4194,
};

// Example marker data
const markersData = [
    { id: 1, position: { lat: 37.7749, lng: -122.4194 }, title: "San Francisco" },
    { id: 2, position: { lat: 34.0522, lng: -118.2437 }, title: "Los Angeles" },
];

const MapWithCurrentLocation = () => {
    // Load the Google Maps API
    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey: "AIzaSyB0Cdp-y1oHDdQ57il5SGWu50jAz7_vx54", // Replace with your actual API Key
    });

    // State to track the current location
    const [currentLocation, setCurrentLocation] = useState(center);
    const [address, setAddress] = useState(""); // State to store the address

    // Fetch the user's current location
    useEffect(() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setCurrentLocation({
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    });
                },
                (error) => {
                    console.error("Error retrieving location:", error);
                    alert("Unable to retrieve your location.");
                }
            );
        } else {
            alert("Geolocation is not supported by this browser.");
        }
    }, []);

    // Function to handle marker click and reverse geocode
    const handleMarkerClick = (position) => {
        if (window.google) { // Access google object through window
            const geocoder = new window.google.maps.Geocoder();
            geocoder
                .geocode({ location: position })
                .then((response) => {
                    if (response.results[0]) {
                        setAddress(response.results[0].formatted_address); // Set the address
                        alert(`Address: ${response.results[0].formatted_address}`); // Show address in alert
                    } else {
                        console.log("No results found");
                    }
                })
                .catch((error) => {
                    console.error("Geocoder failed due to: ", error);
                });
        } else {
            console.log("Google Maps API is not loaded yet.");
        }
    };

    // Handle API loading error
    if (loadError) return <div>Error loading Google Maps</div>;
    if (!isLoaded) return <div>Loading...</div>;

    return (
        <div>
            <GoogleMap
                mapContainerStyle={containerStyle}
                center={currentLocation}
                zoom={14}
            >
                {/* Current Location Marker */}
                <Marker position={currentLocation} />

                {/* Render other markers */}
                {markersData.map((marker) => (
                    <Marker
                        key={marker.id}
                        position={marker.position}
                        onClick={() => handleMarkerClick(marker.position)} // Handle marker click
                    />
                ))}
            </GoogleMap>

            {/* Optionally, display the address somewhere else on the page */}
            {address && <div>Address: {address}</div>}
        </div>
    );
};

export default MapWithCurrentLocation;

